import { SET_PRICING_LOADS, UPDATE_PRICING_LOAD } from '../actionTypes'

const initialState = []



export default (state=initialState,  payload) => {
    let loads = initialState
    //(payload.type === SET_PRICING_LOADS) ? payload.loads || initialState : state

    if (payload.type === SET_PRICING_LOADS) {
        loads = payload.loads || initialState
    } else if (payload.type === UPDATE_PRICING_LOAD) {
        const inx = state.findIndex(l => l.id === payload.load?.id)
        if (inx >= 0) {
            loads = [...state]
            loads[inx] = payload.load
        }

    } else {
        loads = state
    }


    return loads
}